import React from "react"
import { ButtonGroup, Modal } from "react-bootstrap";
import { Button } from "../../../components";

const DownloadModal = (props: any) => {
  const { downloadModalOpen, setDownloadModalOpen, handleDownload } = props
  return (
    <Modal
      show={downloadModalOpen}
      onHide={() => setDownloadModalOpen(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="regenerate-password"
    >
      <Modal.Header className="border-0 pb-0 pb-2" closeButton>
        <Modal.Title id="contained-modal-title-vcenter fw-semibold">
          Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you want to Download Report ?</p>
        <div className="text-end">
          <ButtonGroup>
            <Button
              type="button"
              bname="No"
              name="no"
              id="No"
              onClick={() => setDownloadModalOpen(false)}
              className="btn btn-light rounded-1 mt-1  me-3"
            ></Button>
            <Button
              onClick={handleDownload}
              type="button"
              bname="Yes"
              name="yes"
              id="yes"
              className="btn btn-primary rounded-1 mt-1"
            ></Button>
          </ButtonGroup>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export { DownloadModal }